import React, { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function HeroVideo() {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    const v = ref.current;
    if (!v) return;
    const next = !muted;
    v.muted = next;
    if (!next) {
      v.play().catch(() => {});
    }
    setMuted(next);
  };

  return (
    <div className="relative overflow-hidden rounded-xl bg-pulse-navy shadow-pulse-lg" data-testid="hero-video">
      <video
        ref={ref}
        src="/video.mp4"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="h-full w-full object-cover"
      />
      <button
        onClick={toggleMute}
        data-testid="hero-video-mute"
        aria-label={muted ? "Unmute video" : "Mute video"}
        className="absolute bottom-3 right-3 flex items-center gap-1.5 rounded-full bg-black/55 px-3.5 py-2 text-xs font-semibold text-white backdrop-blur-sm transition-transform hover:scale-105 active:scale-95"
      >
        {muted ? <VolumeX size={15} /> : <Volume2 size={15} />}
        {muted ? "Tap for sound" : "Mute"}
      </button>
    </div>
  );
}
